<script>
import Drawer from "@/components/drawer.vue";
import Swal from "sweetalert2";

// Custom Components
import PageHeader from "@/components/page-header";
import DomainDetails from "@/components/superAdmin/domain/domainForm.vue";
import PbxService from "@/helpers/APIService/pbx.service";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";
import HandleLogic from "@/helpers/handleLogic";

export default {
  page: {
    title: "Domain list",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    DomainDetails,
    PageHeader,
  },
  data() {
    return {
      title: "domain list",
      domaindata: [],
      isShowDomainForm: false,
      selectedDomainId: null,
      isStillLoading: false,
      isEdit: false,
      hotels: [],
      query:
        "?column=domain_uuid&column=domain_name&column=domain_description&column=pbx&column=domain_subscription&column=domain_enabled",
      isFilterLoading: false,
      filter: {
        domain_name: "",
        server: "",
        service_status: "",
      },
      baseQuery: "",
      isChangeFilterValue: false,
      isFilterApply: false,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getDomain();
  },
  methods: {
    // Method is used to handle filter reset
    async filterApply(proccess) {
      if (proccess == "clear") {
        this.isFilterLoading = true;
        await this.getDomain(this.query);
        this.baseQuery = this.query;
        this.isFilterApply = false;
        this.filter.domain_name = "";
        this.filter.server = "";
        this.filter.service_status = "";
      } else {
        this.isFilterApply = true;
        this.baseQuery = this.query;
        if (this.filter.domain_name !== "") {
          this.baseQuery += `&domain_name=${this.filter.domain_name}`;
        }
        if (this.filter.server !== "") {
          this.baseQuery += `&pbx=${this.filter.server}`;
        }
        if (this.filter.service_status !== "") {
          this.baseQuery += `&domain_enabled=${this.filter.service_status}`;
        }
        if (this.baseQuery !== this.query) {
          this.isFilterLoading = true;
          await this.getDomain(this.baseQuery);
        }
      }
    },
    // Method is used to get doamin list
    async getDomain(query) {
      this.isStillLoading = true;
      try {
        this.domaindata = [];
        const response = await PbxService.getDomainList(
          query ? query : this.query
        );
        if (response) {
          response.map((item) => {
            this.domaindata.push({
              ...item,
              domain_enabled: item.domain_enabled == "true" ? true : false,
            });
          });
          this.isStillLoading = false;
          this.isFilterLoading = false;
          localStorage.setItem("domain_list", btoa(JSON.stringify(response)));
        }
      } catch (error) {
        errorHandler(error);
        this.isStillLoading = false;
        this.isFilterLoading = false;
      }
    },
    // Method is used to update domain details
    updateDomainDetail(domain_uuid) {
      this.isEdit = true;
      this.selectedDomainId = domain_uuid;
      this.isShowDomainForm = !this.isShowDomainForm;
    },
    // Method is used to handle PBX form
    DomainForm() {
      this.isEdit = false;
      this.selectedDomain = null;
      this.isShowDomainForm = !this.isShowDomainForm;
    },
    // Method is used to handle hotel submission
    handleDomainubmit() {
      this.DomainForm();
      this.getDomain();
    },
    // Method is used to handle domain status change
    changeStatus(domain) {
      PbxService.updateDomainStatus(domain.domain_uuid, {
        domain_enabled: !domain.domain_enabled,
      })
        .then((response) => {
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          }
          Middleware.notification("Status change successfully !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to delete domain
    deleteDomain(id, index) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#238dfa",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          PbxService.deleteDomain(id)
            .then((response) => {
              if (response.status == false) {
                return Middleware.notification(response.message, "warning");
              }
              Middleware.notification(
                "Domain deleted successfully !!",
                "danger"
              );
              this.domaindata.splice(index, 1);
            })
            .catch((error) => {
              errorHandler(error);
            });
        }
      });
    },
    copyCode(data) {
      Middleware.copyCode(data);
    },
    openDomain(domain) {
      if (domain.domain_uuid !== null) {
        HandleLogic.openPbxDomain({ domain_uuid: domain.domain_uuid });
      }
    },
  },
};
</script>
<template>
  <div>
    <PageHeader :title="title" />
    <b-card>
      <div class="row">
        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
          <input
            type="text"
            class="form-control mb-2"
            placeholder="search domain name"
            v-model="filter.domain_name"
            id="domain_name"
            name="domain_name"
          />
        </div>
        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
          <input
            type="text"
            class="form-control mb-2"
            placeholder="search by server"
            v-model="filter.server"
            id="pbx_server"
            name="pbx_server"
          />
        </div>
        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-6">
          <select
            name="is_active"
            id="is_active"
            class="form-control mb-2"
            v-model="filter.service_status"
            placeholder="Domain active status"
          >
            <option value="">Service Status</option>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>
        <div class="col-xxl-2 col-lg-3 col-md-12 col-sm-6">
          <div class="float-end float-lg-start">
            <button
              class="btn btn-primary mb-2 me-2"
              @click="filterApply('apply')"
              :disabled="isFilterLoading"
            >
              Apply Filter
            </button>
            <button
              class="btn btn-primary mb-2"
              @click="filterApply('clear')"
              :disabled="isFilterLoading"
            >
              Clear Filter
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead class="table-light">
            <tr>
              <th>Name</th>
              <th>ID</th>
              <th>Server</th>
              <th>Description</th>
              <th>Subscription</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody v-if="isStillLoading">
            <tr v-for="item in 10" :key="item">
              <td class="placeholder-glow" v-for="no in 7" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(domain, index) in domaindata" :key="domain.id">
              <td>
                <span @click="openDomain(domain)" class="text-primary cursor">
                  {{ domain.domain_name ? domain.domain_name : "-" }}
                </span>
                <i
                  class="far fa-copy text-primary ms-1"
                  @click="copyCode(domain.domain_name)"
                ></i>
              </td>
              <td>
                <span>
                  {{ domain.domain_uuid ? domain.domain_uuid : "-" }}</span
                >
                <i
                  class="far fa-copy text-primary ms-1"
                  @click="copyCode(domain.domain_uuid)"
                ></i>
              </td>
              <td>
                {{ domain.pbx ? domain.pbx : "-" }}
              </td>
              <td class="text-truncate">
                {{
                  domain.domain_description ? domain.domain_description : "-"
                }}
              </td>
              <td class="text-capitalize">
                {{
                  domain.domain_subscription
                    ? domain.domain_subscription == "active"
                      ? "Active"
                      : "Inactive"
                    : "-"
                }}
              </td>

              <td>
                <div class="form-check form-switch my-1" slot="domain_enabled">
                  <input
                    class="form-check-input"
                    id="domain_enabled"
                    type="checkbox"
                    v-model="domain.domain_enabled"
                    @click="changeStatus(domain)"
                  />
                </div>
              </td>
              <td>
                <i
                  v-b-popover.hover="'Edit'"
                  class="fas fa-pencil-alt text-success"
                  @click="updateDomainDetail(domain.domain_uuid)"
                >
                </i>
                <div class="d-flex align-items-center">
                  <i
                    v-b-popover.hover="'Delete'"
                    class="mdi mdi-trash-can text-danger fs-5 ms-2 d-none"
                    @click="deleteDomain(domain.domain_uuid, index)"
                  ></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>

    <Drawer
      @close="DomainForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1000"
    >
      <div v-if="isShowDomainForm">
        <DomainDetails
          :domainId="this.selectedDomainId"
          :isEdit="this.isEdit"
          @cancelSubmit="DomainForm"
          @submitted="handleDomainubmit"
        />
      </div>
    </Drawer>
  </div>
</template>
